export abstract class DataStoreAbstract {

    suffix: string = '';
    /**
     * Die storeVersion, die hier definiert wird, wird verwendet in
     *      - customer-portal
     *      - react-forms
     *      - partner-portal
     *
     * rental-portal hat eine eigene storeVersion
     */
    storeVersion: number = 10;

    storeData(key: string, value: string | number | object) {
        localStorage.setItem(this.getKey(key), JSON.stringify(value));
    };

    /**
     * @param key
     * @return null|string|number
     */
    retrieveData(key: string) {
        let value = localStorage.getItem(this.getKey(key));
        if (value === 'undefined') {
            return null;
        }

        if (value) {
            return JSON.parse(value);
        }
        return value;
    }

    getKey(key: string) {
        return key + this.suffix + this.storeVersion;
    }

    /**
     * clear complete localstorage with suffix and version.
     */
    clear() {
        const regexp = new RegExp('.*' + this.suffix + this.storeVersion);
        const toDelete: string[] = [];
        for (let i = 0; i < localStorage.length; i++) {
            if (localStorage.key(i).match(regexp)) {
                toDelete.push(localStorage.key(i));
            }
        }

        for (const name of toDelete) {
            localStorage.removeItem(name);
        }
    }

    removeItem(key: string){
        const fullName = this.getKey(key);
        localStorage.removeItem(fullName);
    }

    abstract getUser(): any;
}
